import React from 'react';

import { WidgetViewMode, WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { PinboardWidgetPills } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetPills/PinboardWidgetPills';

interface Props {
    isInPinboard: boolean;
    pills: unknown[];
    widgetViewMode: WidgetViewMode;
}

export const PinboardPills = ({ pills, isInPinboard, widgetViewMode }: Props) => {
    const notInReport = !WidgetViewModeUtils.isReportView(widgetViewMode);

    if (notInReport && isInPinboard && pills && pills?.length > 0)
        return <PinboardWidgetPills key={'widgetFilters'} filters={pills} />;
    else return null;
};
